import IsForYou from "./IsForYou";

export default IsForYou;
